import React from "react";
import { Instagram, Facebook, Youtube, Linkedin, ExternalLink } from "lucide-react";
import { SOCIAL } from "@/constants/social";

// Simple Pinterest / TikTok icons (lucide has Youtube/Instagram/Facebook/Linkedin natively)
const PinterestIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.09 2.46 7.6 5.97 9.14-.08-.78-.16-1.98.03-2.83.17-.75 1.12-4.78 1.12-4.78s-.28-.57-.28-1.4c0-1.32.76-2.3 1.71-2.3.81 0 1.2.61 1.2 1.34 0 .82-.52 2.04-.79 3.17-.22.95.48 1.72 1.42 1.72 1.7 0 3.01-1.8 3.01-4.4 0-2.3-1.66-3.91-4.02-3.91-2.74 0-4.35 2.06-4.35 4.19 0 .83.32 1.72.72 2.2.08.09.09.18.06.28-.07.29-.24.95-.27 1.09-.04.18-.14.22-.32.13-1.19-.55-1.94-2.29-1.94-3.68 0-3 2.18-5.75 6.28-5.75 3.3 0 5.86 2.35 5.86 5.49 0 3.28-2.07 5.92-4.94 5.92-.96 0-1.87-.5-2.18-1.09l-.59 2.26c-.21.83-.79 1.87-1.18 2.5.89.27 1.83.42 2.81.42 5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
  </svg>
);

const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.16 8.16 0 0 0 4.77 1.52V6.89a4.85 4.85 0 0 1-1.84-.2Z"/>
  </svg>
);

const BlogspotIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M14.5 10h-5A1.5 1.5 0 0 0 8 11.5v1A1.5 1.5 0 0 0 9.5 14h5a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5Zm0-4h-3A1.5 1.5 0 0 0 10 7.5v1A1.5 1.5 0 0 0 11.5 10h3A1.5 1.5 0 0 0 16 8.5v-1A1.5 1.5 0 0 0 14.5 6Zm4.5 13a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.59a1 1 0 0 1 .7.29l4.42 4.42a1 1 0 0 1 .29.7V19Z"/>
  </svg>
);

const items = [
  { key: "instagram", label: "Instagram", href: SOCIAL.instagram, Icon: Instagram },
  { key: "facebook", label: "Facebook", href: SOCIAL.facebook, Icon: Facebook },
  { key: "pinterest", label: "Pinterest", href: SOCIAL.pinterest, Icon: PinterestIcon },
  { key: "tiktok", label: "TikTok", href: SOCIAL.tiktok, Icon: TikTokIcon },
  { key: "youtube", label: "YouTube", href: SOCIAL.youtube, Icon: Youtube },
  { key: "linkedin", label: "LinkedIn", href: SOCIAL.linkedin, Icon: Linkedin },
  { key: "blogspot", label: "Blog", href: SOCIAL.blogspot, Icon: BlogspotIcon },
];

export function SocialLinks({ label = "" }) {
  const active = items.filter((i) => i.href);
  if (active.length === 0) return null;
  return (
    <div className="flex flex-col gap-3" data-testid="social-links">
      {label && <div className="overline text-zinc-500">{label}</div>}
      <div className="flex items-center gap-3 flex-wrap">
        {active.map(({ key, label: l, href, Icon }) => (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={l}
            title={l}
            data-testid={`social-${key}`}
            className="w-10 h-10 rounded-full border border-white/10 hover:border-[#D4AF37]/60 text-zinc-400 hover:text-[#D4AF37] flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5"
          >
            <Icon className="w-4 h-4" />
          </a>
        ))}
      </div>
    </div>
  );
}

export default SocialLinks;
